// The user's target size per section. The ranges are orders of magnitude the
// writer aims for, not hard limits; the UI says so.

import type { SectionLength } from '../../types/articleGeneration';

export type { SectionLength };

export const SECTION_LENGTH_LEVELS: SectionLength[] = ['short', 'medium', 'long'];

/** Approximate words per section (the lead counts as a section). */
export const SECTION_LENGTH_WORDS: Record<SectionLength, [number, number]> = {
  short: [50, 100],
  medium: [100, 200],
  long: [200, 350],
};

export const DEFAULT_SECTION_LENGTH: SectionLength = 'medium';

/** Slider level 1-3 → length; out-of-range levels clamp. */
export function sectionLengthFromLevel(level: number): SectionLength {
  const index = Math.min(Math.max(Math.round(level), 1), SECTION_LENGTH_LEVELS.length) - 1;
  return SECTION_LENGTH_LEVELS[index];
}

export function levelFromSectionLength(length: SectionLength | undefined): number {
  const index = SECTION_LENGTH_LEVELS.indexOf(length ?? DEFAULT_SECTION_LENGTH);
  return (index === -1 ? SECTION_LENGTH_LEVELS.indexOf(DEFAULT_SECTION_LENGTH) : index) + 1;
}
